
(function() {
  'use strict';

  function initializeSwitchTypeSelectors() {
    const switchTypeContainers = document.querySelectorAll('.switch-types-display');
    
    if (switchTypeContainers.length === 0) {
      return;
    }

    switchTypeContainers.forEach(container => {
      const switchItems = container.querySelectorAll('.switch-type-item');
      
      if (switchItems.length === 0) {
        return;
      }

      // Remove existing event listeners to prevent duplicates
      switchItems.forEach(item => {
        // Clone the element to remove all event listeners
        const newItem = item.cloneNode(true);
        item.parentNode.replaceChild(newItem, item);
      });

      // Re-query after cloning to get fresh elements
      const newSwitchItems = container.querySelectorAll('.switch-type-item');

      // Add click event listeners to switch type items
      newSwitchItems.forEach(item => {
        item.addEventListener('click', function() {
          // Remove selected class from all items in this container
          newSwitchItems.forEach(otherItem => {
            otherItem.classList.remove('selected');
            otherItem.setAttribute('aria-pressed', 'false');
          });
          
          // Add selected class to clicked item
          this.classList.add('selected');
          this.setAttribute('aria-pressed', 'true');
          
          // Get switch type and option position
          const switchType = this.dataset.switchType;
          const optionPosition = parseInt(this.dataset.optionPosition);
          
          // Update the corresponding variant selector in the correct context
          selectVariantOption(switchType, optionPosition, container);
          
          // Update availability for all switch types
          updateSwitchTypeAvailability();
        });
      });
      
      // Initialize availability on load
      updateSwitchTypeAvailability();
    });

    function selectVariantOption(switchType, optionPosition, switchContainer) {
      // Find the correct product context (modal or main page)
      const productContext = switchContainer.closest('.modal--product') || 
                           switchContainer.closest('product-page') || 
                           document;
      
      // Try to find the variant selectors within the correct context
      const variantSelectors = productContext.querySelectorAll('[data-js-product-variant]');
      
      if (variantSelectors.length > optionPosition) {
        const targetVariantSelector = variantSelectors[optionPosition];
        const variantContainer = targetVariantSelector.querySelector('[data-js-product-variant-container]');
        
        if (variantContainer) {
          if (variantContainer.dataset.jsProductVariantContainer === 'radio') {
            // Handle radio buttons
            const radioInputs = variantContainer.querySelectorAll('input[type="radio"]');
            let found = false;
            
            radioInputs.forEach(input => {
              if (input.value === switchType) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                found = true;
              }
            });
          } else {
            // Handle select dropdown
            const selectElement = variantContainer.querySelector('select') || variantContainer;
            if (selectElement && selectElement.tagName === 'SELECT') {
              const options = selectElement.querySelectorAll('option');
              options.forEach(option => {
                if (option.value === switchType) {
                  selectElement.value = switchType;
                  selectElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
            }
          }
        }
      } else {
        // Try alternative selectors if position-based approach fails, within context
        const switchTypeSelectors = productContext.querySelectorAll('select[id*="switch"], select[id*="Switch"]');
        
        switchTypeSelectors.forEach(selector => {
          const options = selector.querySelectorAll('option');
          options.forEach(option => {
            if (option.value === switchType) {
              selector.value = switchType;
              selector.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
        
        // Also try generic selects that might contain switch types, within context
        const allSelects = productContext.querySelectorAll('select');
        allSelects.forEach(select => {
          const options = select.querySelectorAll('option');
          options.forEach(option => {
            if (option.value === switchType) {
              select.value = switchType;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }
    }

    function updateSwitchTypeAvailability() {
      const switchTypeContainers = document.querySelectorAll('.switch-types-display');
      
      switchTypeContainers.forEach(container => {
        const switchItems = container.querySelectorAll('.switch-type-item');
        
        // Find the correct product context (modal or main page)
        const productContext = container.closest('.modal--product') || 
                             container.closest('product-page') || 
                             document;
        
        // Get variants data from the correct context
        const productVariantsElement = productContext.querySelector('product-variants');
        let variantsData = [];
        
        if (productVariantsElement) {
          const variantsScript = productVariantsElement.querySelector('script[type="application/json"]');
          if (variantsScript) {
            try {
              variantsData = JSON.parse(variantsScript.textContent);
            } catch (e) {
              // Handle JSON parse error silently
            }
          }
        }
        
        if (variantsData.length === 0) {
          // If no variants data, assume all switch types are available
          switchItems.forEach(item => {
            item.classList.remove('disabled');
            item.removeAttribute('data-available');
            const availabilityMessage = container.querySelector(`[data-for="${item.dataset.switchType}"]`);
            if (availabilityMessage) {
              availabilityMessage.textContent = '';
            }
          });
          return;
        }
        
        // Get currently selected options from other variant selectors (excluding switch types)
        const currentSelections = getCurrentVariantSelections(productContext);
        
        switchItems.forEach(item => {
          const switchType = item.dataset.switchType;
          
          // Find variants that match this switch type
          const matchingVariants = variantsData.filter(variant => {
            const variantOptions = variant.options || [];
            return variantOptions.includes(switchType);
          });
          
          const availableVariants = matchingVariants.filter(variant => variant.available);
          const availabilityMessage = container.querySelector(`[data-for="${switchType}"]`);
          
          if (availableVariants.length > 0) {
            // Switch type is available - always keep enabled for user choice
            item.classList.remove('disabled');
            item.setAttribute('data-available', 'true');
            if (availabilityMessage) {
              availabilityMessage.textContent = '';
            }
          } else if (matchingVariants.length > 0) {
            // Switch type exists but not available - still keep enabled for user choice
            item.classList.remove('disabled');
            item.setAttribute('data-available', 'true');
            if (availabilityMessage) {
              availabilityMessage.innerHTML = '<button class="notify-me-btn" onclick="openNotifyMeModal()">Notify me when available</button>';
            }
          } else {
            // Switch type doesn't exist - still keep enabled for user choice
            item.classList.remove('disabled');
            item.setAttribute('data-available', 'true');
            if (availabilityMessage) {
              availabilityMessage.textContent = '';
            }
          }
        });
      });
    }

    function getCurrentVariantSelections(productContext = document) {
      const selections = [];
      const variantSelectors = productContext.querySelectorAll('[data-js-product-variant]');
      
      variantSelectors.forEach(selector => {
        const container = selector.querySelector('[data-js-product-variant-container]');
        let selectedValue = null;
        
        if (container) {
          if (container.dataset.jsProductVariantContainer === 'radio') {
            const checkedInput = container.querySelector('input[type="radio"]:checked');
            if (checkedInput) {
              selectedValue = checkedInput.value;
            }
          } else {
            const selectElement = container.querySelector('select') || container;
            if (selectElement && selectElement.tagName === 'SELECT' && selectElement.selectedIndex > 0) {
              selectedValue = selectElement.value;
            }
          }
        }
        
        selections.push(selectedValue);
      });
      
      return selections;
    }
  }

  // Expose the function globally for external access
  window.initSwitchTypeSelectors = initializeSwitchTypeSelectors;
  window.initializeSwitchTypeSelectors = initializeSwitchTypeSelectors;

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSwitchTypeSelectors);
  } else {
    initializeSwitchTypeSelectors();
  }

  // Re-initialize when quick view is opened
  document.addEventListener('modalOpened', function(e) {
    if (e.target && (e.target.matches('.modal--product') || e.target.querySelector('#product-quick-view'))) {
      setTimeout(initializeSwitchTypeSelectors, 100);
    }
  });

  // Handle quick view loaded event
  document.addEventListener('quickViewLoaded', function() {
    setTimeout(initializeSwitchTypeSelectors, 100);
  });

})(); 